module.exports = __webpack_public_path__ + "img/img-gallery-4.5bd3e827.jpg";